// extracted by mini-css-extract-plugin
module.exports = {"Question":"Question_Question__1hpib"};